import { META } from '../platform/storage';
import { partById } from '../data/parts';
/* 局外裝備 → 部件外形代號。

   放在獨立的小檔案，是為了讓 `entities/mechs.ts` 不用 import 整個
   局外部件系統（那會把存檔與經濟拉進渲染層的相依鏈）。

   讀不到就回退到起手件的形狀 —— headless 測試與尚未載入存檔時都會走這條。 */
export function equippedShape(slot, fallback, mechId) {
  try {
    /* `META.equip` 的第一層是機體 id（每台各一套，見 `platform/storage.ts`）。
       **mechId 是必填**：這裡刻意不從 `world/player` 取當前機體 —— 那會把
       存檔與經濟拉進渲染層的相依鏈，而每個 builder 本來就知道自己是誰。 */
    var byMech = META.equip && (META.equip as any)[mechId];
    var id = byMech && byMech[slot];
    var p = id ? partById(id) : null;
    return p && p.shape ? p.shape : fallback;
  } catch (e) { return fallback; }
}
